import { sortWorkspacesByOrder } from '@/utils/navigation/canShowMenu'

export { WORKSPACE_ORDER, sortWorkspacesByOrder } from '@/utils/navigation/canShowMenu'

/**
 * Default shell when switching branch — first match in fixed order (see `WORKSPACE_ORDER`).
 */
export function pickDefaultWorkspace(available: string[] | undefined | null): string | null {
  const sorted = available?.length ? sortWorkspacesByOrder(available) : []
  return sorted[0] ?? null
}

export const ACTIVE_WORKSPACE_STORAGE_PREFIX = 'vidhyantra.activeWorkspace:'

export function activeWorkspaceStorageKey(organizationId: string | undefined, branchId: string | undefined): string {
  return `${ACTIVE_WORKSPACE_STORAGE_PREFIX}${organizationId ?? 'x'}:${branchId ?? 'x'}`
}

export function readStoredWorkspace(organizationId: string | undefined, branchId: string | undefined): string | null {
  if (typeof window === 'undefined') return null
  const k = activeWorkspaceStorageKey(organizationId, branchId)
  try {
    const fromSession = sessionStorage.getItem(k)
    if (fromSession != null) return fromSession
  } catch {
    /* ignore */
  }
  try {
    return localStorage.getItem(k)
  } catch {
    return null
  }
}

export function writeStoredWorkspace(
  organizationId: string | undefined,
  branchId: string | undefined,
  value: string | null
): void {
  if (typeof window === 'undefined') return
  const k = activeWorkspaceStorageKey(organizationId, branchId)
  try {
    if (value == null) {
      sessionStorage.removeItem(k)
      localStorage.removeItem(k)
    } else {
      sessionStorage.setItem(k, value)
      try {
        localStorage.setItem(k, value)
      } catch {
        /* ignore quota / private mode */
      }
    }
  } catch {
    /* ignore */
  }
}
